{
  "name": "TeslaWave",
  "domain": "teslawave.app",
  "url": "https://teslawave.app",
  "contact": "contact@teslawave.app",
  "tagline": "Wave at other Teslas",
  "title": "Wave at other Teslas on the road — live map from your Tesla screen",
  "description": "A live map of the Teslas around you, on your car screen: wave when one comes close, report police or an accident. Free, no account, no position stored.",
  "imageAlt": "A blue Tesla seen from above on a dark ground, with the words Wave at other Teslas and the address teslawave.app",
  "disclaimer": "Independent project. Not affiliated with, endorsed or sponsored by Tesla, Inc. TESLA is a trademark of Tesla, Inc."
}
